import React from "react";
import styled from "styled-components";
import RequestMedSKUForm from "components/Common/forms/RequestMedSKUSample";
import Modal from "react-modal";
import { modalStyles } from "styles/modals";

const MedSKUAdvertisement = () => {
  const [toggleModal, setToggleModal] = React.useState(false);

  const handleButtonClick = () => {
    setToggleModal(true);
  };
  
  return (
    <>
      <Container>
        <Header>
          Brand and SKU-Level Market and Competitor Share Data
        </Header>      
        <Button onClick={handleButtonClick}>
          Get free sample
        </Button>
      </Container>

      <Modal
        isOpen={toggleModal}
        contentLabel="Contact Us"
        style={modalStyles}
      >
        <RequestMedSKUForm setToggleModal={setToggleModal} />
      </Modal>
    </>
  )
}

const Container = styled.div`
  background-color: ${(props) => props.theme.colors.idataDarkBlue};
  border-radius: 1rem;
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  gap: 1.5rem;
  text-align: center;
`;

const Header = styled.div`
  font-weight: 500;
  font-size: 2rem;
  color: white;
`

const Button = styled.button`
  border: solid 1px #5dc097;
  background: #5dc097;
  padding: 1.25rem;
  font-size: 2rem;
  transition: opacity 0.2s ease-in-out;
  border-radius: 8px;

  &:hover {
    opacity: 0.85;
  }
`

export default MedSKUAdvertisement;